/**
 * Tab config mirror cho Access form `frmMatchingPSMain` (file
 * `frontend/plan/access_all/form_frmMatchingPSMain.txt` – NavigationControl0).
 *
 * Access có 6 navigation button nhưng chỉ 4 visible:
 *   - navMatch2                  (TabIndex=1) → "Match - Instruct"
 *   - navMatchStockSales         (TabIndex=2) → "Stock to Sales"
 *   - NavigationButton39         (TabIndex=3) → "S Contract"
 *   - NavigationButton41         (TabIndex=4) → "P Contract"
 *   - navProcurementPreferences  (TabIndex=5) → "References"   ⟵ Visible=NotDefault (hidden)
 *   - NavigationButton1          (TabIndex=6) → "[Add New]"    ⟵ Access design-mode placeholder
 */

export type ContractOverviewTabKey =
  | 'match-instruct'
  | 'stock-sales'
  | 's-contract'
  | 'p-contract'

export interface ContractOverviewTabDef {
  key: ContractOverviewTabKey
  /** Caption Access — nhãn hiển thị trên tab strip. */
  label: string
  /** Access subform/target gốc — dùng làm tham chiếu cho dev sau này. */
  accessSource: string
  /** Mô tả ngắn dùng cho placeholder card. */
  description: string
  /** Ẩn khỏi tab strip (route + renderTab vẫn hoạt động khi truy cập trực tiếp). */
  hidden?: boolean
}

export const CONTRACT_OVERVIEW_TABS: ContractOverviewTabDef[] = [
  {
    key: 'match-instruct',
    label: 'Match - Instruct',
    accessSource: 'frmMatchingPSMainSubForm',
    description:
      'Match-Instruct overview — contains two subforms (Contract P / Contract S) ' +
      'plus date and category filters.',
  },
  {
    key: 'stock-sales',
    label: 'Stock to Sales',
    accessSource: 'frmMatchingPSMatch_Stock_Sales',
    description:
      'Allocating Stock ↔ Sales — datasheet with editable cells: ' +
      'match_date / quantity / quality / client / allocated / instructed.',
    hidden: true,
  },
  {
    key: 's-contract',
    label: 'S Contract',
    accessSource: 'frmMatchingPSMatchLocalSQry',
    description:
      'S Contract list — RecordSource MatchingPSMatch_Ref_LocalS → SELECT * FROM ' +
      'public.v_report_matching_locals.',
  },
  {
    key: 'p-contract',
    label: 'P Contract',
    accessSource: 'frmMatchingPSMatchLocalPQry',
    description:
      'P Contract list — RecordSource MatchingPSMatch_Ref_LocalP → SELECT * FROM ' +
      'public.v_report_matching_localp.',
  },
]

export const CONTRACT_OVERVIEW_TAB_KEYS = CONTRACT_OVERVIEW_TABS.map((t) => t.key)

/** Tab hiển thị trên strip (loại bỏ tab `hidden`). */
export const VISIBLE_CONTRACT_OVERVIEW_TABS = CONTRACT_OVERVIEW_TABS.filter((t) => !t.hidden)

export const VISIBLE_CONTRACT_OVERVIEW_TAB_KEYS = VISIBLE_CONTRACT_OVERVIEW_TABS.map((t) => t.key)

/** Chỉ key của tab KHÔNG ẩn mới được điều hướng tới (hidden → redirect về default). */
export function isVisibleContractOverviewTabKey(
  v: string | undefined,
): v is ContractOverviewTabKey {
  if (!v) return false
  return (VISIBLE_CONTRACT_OVERVIEW_TAB_KEYS as readonly string[]).includes(v)
}

export function isContractOverviewTabKey(v: string | undefined): v is ContractOverviewTabKey {
  if (!v) return false
  return (CONTRACT_OVERVIEW_TAB_KEYS as readonly string[]).includes(v)
}

export const DEFAULT_CONTRACT_OVERVIEW_TAB: ContractOverviewTabKey = 'match-instruct'
